module.exports = __webpack_public_path__ + "static/TangleTower4-f8e1caa9867babfd465952113c7244a4.png";